import { FiArrowRight, FiChevronLeft } from "react-icons/fi";
import Button from "../../../../shared/components/Button";
import { handleSupportPrevious } from "../../utils/supportNavUtils";

const SupportNavigationButtons = ({
  prevStep = true,
  nextStep = true,
  isValid,
  onClick,
  type = "submit",
}) => (
  <div
    className={`tw-mx-auto tw-my-6 tw-flex tw-w-full tw-max-w-[600px] tw-items-center ${
      prevStep ? "tw-justify-between" : "tw-justify-end"
    } max-[640px]:tw-gap-3`}
  >
    {prevStep && (
      <Button
        type="button"
        aria-label="Previous step"
        variant="back"
        size="circle"
        onClick={() => handleSupportPrevious(prevStep)}
        trailingIcon={
          <FiChevronLeft
            className="tw-h-[22px] tw-w-[22px]"
            strokeWidth={2.4}
            aria-hidden="true"
          />
        }
      />
    )}

    {nextStep && (
      <Button
        type={type}
        onClick={isValid ? onClick : undefined}
        aria-disabled={!isValid}
        variant={isValid ? "main" : "disabled"}
        size="card"
        className="tw-mt-0 tw-gap-1 tw-pl-5 tw-pr-4 [caret-color:transparent] max-[640px]:tw-w-full max-[640px]:tw-flex-1"
        trailingIcon={
          <FiArrowRight
            className="tw-h-5 tw-w-5"
            strokeWidth={2.3}
            aria-hidden="true"
          />
        }
      >
        Next
      </Button>
    )}
  </div>
);

export default SupportNavigationButtons;
